"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllANGTypes = void 0;
const getAllANGTypes = (assetTypesConfiguration, featureFlags) => Object.keys(assetTypesConfiguration).reduce((accum, typeKey) => {
  const assetTypeConfiguration = assetTypesConfiguration[typeKey];
  if (!assetTypeConfiguration.angType) {
    return accum;
  }
  if (!assetTypeConfiguration.filter) {
    return accum;
  }
  if (assetTypeConfiguration.featureFlag && !(featureFlags !== null && featureFlags !== void 0 && featureFlags[assetTypeConfiguration.featureFlag])) {
    return accum;
  }
  if (accum.some(existingType => existingType === assetTypeConfiguration.angType)) {
    return accum;
  }
  return [...accum, assetTypeConfiguration.angType];
}, []);
exports.getAllANGTypes = getAllANGTypes;
//# sourceMappingURL=types.js.map